import { render, staticRenderFns } from "./TableFormSpan.vue?vue&type=template&id=5229c388"
import script from "./TableFormSpan.vue?vue&type=script&lang=js"
export * from "./TableFormSpan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports